'use strict';

var _promisePolyfill = require('promise-polyfill');

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _ViewerApp = require('../scenes/ViewerApp.js');

var _ViewerApp2 = _interopRequireDefault(_ViewerApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// To add to window
if (!window.Promise) {
  window.Promise = _promisePolyfill2.default;
}

if (module.hot) {
  module.hot.accept();
}

function init(_ref) {
  var formId = _ref.formId,
      apiRoot = _ref.apiRoot,
      onSubmit = _ref.onSubmit,
      onError = _ref.onError,
      onInit = _ref.onInit,
      preset = _ref.preset,
      onChange = _ref.onChange,
      _ref$dataProcessor = _ref.dataProcessor,
      dataProcessor = _ref$dataProcessor === undefined ? function (data) {
    return data;
  } : _ref$dataProcessor,
      hidden = _ref.hidden,
      readonly = _ref.readonly,
      _ref$rootId = _ref.rootId,
      rootId = _ref$rootId === undefined ? 'defaultFormId' : _ref$rootId;

  var rootElement = document.getElementById(rootId);

  if (rootElement && formId) {
    (0, _reactDom.render)(_react2.default.createElement(_ViewerApp2.default, {
      formId: formId,
      onSubmit: onSubmit,
      onChange: onChange,
      onError: onError,
      onInit: onInit,
      apiRoot: apiRoot,
      dataProcessor: dataProcessor,
      preset: preset,
      hidden: hidden || [],
      readonly: readonly || []
    }), rootElement);
  }
}

window.schemaFormViewer = {
  init: init,
  Component: _ViewerApp2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/entrypoints/viewer.js
// module id = 1709
// module chunks = 5